import { ReactNode } from 'react';
import { Box, useModal } from '@gousto-internal/citrus-react';

import { RecipeImage } from '../RecipeImage/RecipeImage';
import { Footer } from './Footer';
import { ClickableArea } from './ClickableArea';
import { Container, GridAreas, IMAGE_HEIGHTS } from './layout';
import { RECIPE_MODAL_NAME_PREFIX } from '../../utils/constants';

export type Recipe = {
  id: string;
  name: string;
  primaryImage: string;
  description: string;
  foodBrand?: string;
};

type Props = {
  children?: ReactNode | ReactNode[];
  recipe: Recipe;
  disabled?: boolean;
  footerContent: ReactNode;
};

export function RecipeCard({ children, recipe, disabled = false, footerContent }: Props) {
  const { openModal } = useModal();

  function openRecipeModal() {
    openModal(`${RECIPE_MODAL_NAME_PREFIX}${recipe.id}`);
  }

  return (
    <Container data-testid="recipe-card-container" aria-label={`Recipe card for ${recipe.name}`}>
      <ClickableArea
        aria-label={`Display recipe details for ${recipe.name}`}
        data-testid="recipe-card"
        onClick={openRecipeModal}
        disabled={disabled}
        style={{ opacity: disabled ? 0.3 : 1 }}
      >
        <Box gridArea={GridAreas.IMAGE}>
          <Box height={IMAGE_HEIGHTS}>
            <RecipeImage primaryImageUrl={recipe.primaryImage} />
          </Box>
        </Box>
        <Footer>{footerContent}</Footer>
      </ClickableArea>
      {children}
    </Container>
  );
}
